import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const cols = [
    {
        title: "Product",
        links: [
            ["CRM", "#features"],
            ["Leads", "#lead-management"],
            ["Pipeline", "#pipeline"],
            ["Automation", "#automation"],
            ["Engage", "#engage"],
            ["Field Sales", "#field-sales"],
            ["Analytics", "#ecosystem"],
        ],
    },
    {
        title: "Solutions",
        links: [
            ["Real Estate", "#industries"],
            ["Staffing", "#industries"],
            ["B2B Sales", "#industries"],
            ["Growing Businesses", "#industries"],
        ],
    },
    {
        title: "Resources",
        links: [
            ["Features", "#features"],
            ["Pricing", "#pricing"],
            ["Guides", "#manifesto"],
            ["Blog", "/blog"],
            ["FAQs", "#faq"],
        ],
    },
    {
        title: "Company",
        links: [
            ["About Kryvo", "#ecosystem"],
            ["Contact", "#footer"],
            ["Careers", "#footer"],
            ["Privacy", "#footer"],
            ["Terms", "#footer"],
        ],
    },
];

const Footer = () => (
    <footer id="footer" data-testid="footer-container" className="border-t border-[#E5E7EB] bg-[#FBFDFC]">
        <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
            <div className="grid gap-12 lg:grid-cols-[1.3fr_2fr]">
                <div>
                    <Link to="/" className="inline-flex items-center" aria-label="Kryvo CRM home">
                        <Logo />
                    </Link>
                    <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#64748B]">
                        Smart Technology for Growing Businesses.
                    </p>
                    <span
                        data-testid="footer-status-badge"
                        className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#E5E7EB] bg-white px-3.5 py-1.5 text-xs font-semibold text-[#475569]"
                    >
                        <span className="relative flex h-2 w-2">
                            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#16A34A] opacity-60" />
                            <span className="relative inline-flex h-2 w-2 rounded-full bg-[#16A34A]" />
                        </span>
                        All systems operational
                    </span>
                </div>
                <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
                    {cols.map((c) => (
                        <div key={c.title}>
                            <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#111827]">{c.title}</p>
                            <ul className="mt-4 grid gap-2.5">
                                {c.links.map(([label, href]) => (
                                    <li key={label}>
                                        <a
                                            href={href}
                                            className="text-sm font-medium text-[#64748B] transition-colors hover:text-[#15803D]"
                                        >
                                            {label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-[#E5E7EB] pt-8 sm:flex-row">
                <p className="text-[13px] text-[#94A3B8]">
                    © {new Date().getFullYear()} Kryvo Technologies. All rights reserved.
                </p>
                <div className="flex items-center gap-6 text-[13px] font-medium text-[#94A3B8]">
                    <a href="#footer" className="hover:text-[#15803D]">Privacy</a>
                    <a href="#footer" className="hover:text-[#15803D]">Terms</a>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
